import { Box } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import {
    getUserError,
    getUserLoading,
    getUserStatus,
    getUserSuccess,
    updateStatus,
    modifyUserFromPermission,
} from "../../features/userSlice";
import UserForm from "../users/userForm";
import BackButton from "../../components/backButton";
import RestaurantAppBar from "../../components/restaurantTopBar";
import { selectAuthUser } from "../../features/authSlice";
import { useTranslation } from "react-i18next";

const ModifyUserFromPermission = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.user;
    const status = useSelector(getUserStatus);
    const error = useSelector(getUserError);
    const loading = useSelector(getUserLoading);
    const success = useSelector(getUserSuccess);
    const authUser = useSelector(selectAuthUser);
    const isSelfEdit =
        Boolean(authUser?._id && data?._id) &&
        String(authUser._id) === String(data._id);

    const initialValues = {
        email: data.email,
        firstName: data.fullName.split(" ")[0],
        lastName: data.fullName.split(" ")[1],
        role: data.role,
        password: "",
        confirmPassword: "",
    };

    const handleFormSubmit = (values) => {
        const requestBody = {
            email: values.email,
            fullName: values.firstName + " " + values.lastName,
        };
        if (!isSelfEdit) {
            requestBody.role = values.role;
        }
        dispatch(
            modifyUserFromPermission({
                body: requestBody,
                userId: data._id,
            })
        );
    };

    useEffect(() => {
        if (status === "modifySuccess") {
            toast.success(success);
            dispatch(updateStatus());
            navigate("/user-permissions");
        } else if (status === "modifyError") {
            toast.error(error);
        }
    }, [status, error, dispatch, navigate, success]);

    return (
        <div className="main-application">
            <RestaurantAppBar />
            <Box m="20px" className="main-application">
                <BackButton />
                <Header
                    title={t("headers.editUser")}
                    subtitle={t("headers.editUserSub")}
                />
                <UserForm
                    buttonText={t("common.edit")}
                    handleFormSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    loading={loading}
                    editingUserId={data._id}
                    requirePassword={false}
                />
            </Box>
        </div>
    );
};

export default ModifyUserFromPermission;
